var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.906,
    height: 53,
    viewBox: "0 0 52.906 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "insta",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2902",
    "data-name": "Trac\\xE9 2902",
    d: "M51.906,26A25.953,25.953,0,1,1,25.953,0,25.976,25.976,0,0,1,51.906,26",
    transform: "translate(0 -0.001)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2903",
    "data-name": "Trac\\xE9 2903",
    d: "M90.213,81.618h15.267a8.993,8.993,0,0,1,8.939,8.964v15.231a8.993,8.993,0,0,1-8.939,8.964H90.213a8.993,8.993,0,0,1-8.939-8.964V90.582a8.993,8.993,0,0,1,8.939-8.964m16.532,5.791h0a1.9,1.9,0,0,1,0,3.808,1.9,1.9,0,0,1,0-3.808m-8.939,1.745h.079a9.043,9.043,0,0,1,0,18.086h-.079a9.044,9.044,0,0,1,0-18.086m0,3.094h.079a5.989,5.989,0,0,1,0,11.978h-.079a5.989,5.989,0,0,1,0-11.978m-7.515-7.774H105.4a6.187,6.187,0,0,1,6.17,6.187v15.072a6.187,6.187,0,0,1-6.17,6.187H90.292a6.187,6.187,0,0,1-6.17-6.187V90.661a6.187,6.187,0,0,1,6.17-6.187",
    transform: "translate(-71.893 -72.197)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.403570f8aff36c26c71a28e5e2cde94d.svg";
export { ForwardRef as ReactComponent };